import classNames from 'classnames';
import emojiRegex from 'emoji-regex';

export const VERSION = '1.0.0';

// Accept Blue
export const aBToken = process.env.REACT_APP_ACCEPT_BLUE_TOKEN;
export const aBPolyFill = process.env.REACT_APP_ACCEPT_BLUE_POLYFILL_SOURCE;
export const aBSource = process.env.REACT_APP_ACCEPT_BLUE_SOURCE;

// Google address validation
export const googleAddressValidationApiKey =
  process.env.REACT_APP_GOOGLE_ADDRESS_VALIDATION_API_KEY;

export const equifaxAllowAccessUrl =
  process.env.REACT_APP_EQUIFAX_ALLOW_ACCESS_URL ||
  'https://uat-ext-allow-access.equifax.com/status/block';

export const equifaxAllowAccessEnabled = ['true', '1', 'yes', 'on'].includes(
  (process.env.REACT_APP_EQUIFAX_ALLOW_ACCESS_ENABLED || '').toLowerCase()
);

export const decisions = {
  APPROVED: 'approved',
  DECLINED: 'declined',
  PENDING: 'pending',
};

export const platform = () => {
  return process.env.REACT_APP_ENV;
};

export const server = () => {
  return process.env.REACT_APP_API;
};

const authorizedSubDomains = ['apply', 'recharge', 'vip', 'netx', 'instore'];
export const subDomains = {
  // returns a merchant public_key, prequalification_id (if present) and the url params
  parseParams: (params) => [
    params.public_key,
    params.prequalification_id || '',
    new URL(document.location).searchParams,
  ],
  authorized: (flag) =>
    authorizedSubDomains.includes(flag ? flag : subDomains.subDomain()),
  subDomain: () =>
    authorizedSubDomains.find((sd) => subDomains.rawSubDomain.includes(sd)),
  rawSubDomain: window.location.hostname.split('.')[0],
};

export const borrowerPortalUrl = process.env.REACT_APP_BORROWER_PORTAL_URI;

export const payNowUrl =
  process.env.REACT_APP_PAY_NOW_URL || 'http://paynow.creditkey.localhost';

export const dateFormat = 'YYYY-MM-DD HH:MM:SSZ';

export const formStyles = {
  error: (error) =>
    classNames('input focus:border-primary-blue', {
      '!border-error': error,
    }),
  input: (multi, error) =>
    classNames('w-full', multi ? 'mb-2 sm:mb-2' : 'mb-2 ', {
      'mb-0 sm:mb-2': error,
    }),
  validation: 'text-error text-xxs sm:text-xs text-left',
};

export const supportPhone = '8443343636';
export const declinedSupportPhone = '8449003330';

export const appLinks = {
  appStore: 'https://apps.apple.com/us/app/credit-key/id6503043940',
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.creditkey.android&hl=en_US',
};

export const suffixes = [
  ['', ''],
  ['Jr', 'Jr'],
  ['Sr', 'Sr'],
  ['II', 'II'],
  ['III', 'III'],
  ['IV', 'IV'],
  ['V', 'V'],
  ['DDM', 'DDM'],
  ['DDS', 'DDS'],
  ['DO', 'DO'],
  ['ESQ', 'ESQ'],
  ['MD', 'MD'],
  ['RN', 'RN'],
];

export const business_types = [
  ['', ''],
  ['LLC', 'LLC'],
  ['Sole Proprietorship', 'Sole Proprietorship'],
  ['Corporation (Not Publicly Traded)', 'Corporation'],
  ['Partnership', 'Partnership'],
  ['Publicly Traded Company (NYSE, NASDAQ, etc.)', 'Publicly Traded Company'],
  [
    'Government Funded Entities (Public School, City, state agency, etc.)',
    'Government',
  ],
  ['Nonprofit Organization', 'Nonprofit Corporation'],
];

export const states = [
  ['', ''],
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Louisiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['Washington DC', 'DC'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
];

export const tradeCreditAmounts = [
  ['', ''],
  ['$5,000', '5,000'],
  ['$10,000', '10,000'],
  ['$25,000', '25,000'],
  ['$50,000', '50,000'],
  ['$75,000', '75,000'],
  ['$100,000', '100,000'],
  ['$150,000', '150,000'],
  ['$200,000', '200,000'],
  ['$250,000', '250,000'],
  ['$300,000', '300,000'],
  ['$350,000+', '350,000'],
];

export const streetTypes = [
  'avenue',
  'ave',
  'boulevard',
  'blvd',
  'street',
  'st',
  'road',
  'rd',
  'drive',
  'dr',
  'court',
  'ct',
  'lane',
  'ln',
  'circle',
  'cir',
];
export const directionalAbbreviations = [
  'n',
  'north',
  's',
  'south',
  'e',
  'east',
  'w',
  'west',
  'nw',
  'sw',
  'ne',
  'se',
];

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const poBoxRegex =
  /POST OFFICE BOX|POST OFFICE BIN|PO BOX|PO BIN|P.O.BOX|P.O. BOX|P. O. BOX|P O BOX|BOX [0-9]|PO .BOX|POBOX|BOX[0-9]|BOXES [0-9]/i;
export const nameRegex = /^[A-Za-z ]+$/;
export const emojiRegexTest = emojiRegex();
export const valuePropsExcludedFromModes = ['modal'];

export const checkEmail = (val) => {
  const tld = val.substr(val.lastIndexOf('.') + 1);

  if (
    [
      'con',
      'cok',
      'fom',
      'comm',
      'coml',
      'comt',
      'ccom',
      'ney',
      'edi',
      'cpm',
      'comq',
      'com2',
    ].includes(tld)
  )
    return false;

  return true;
};
